import type { User } from '@rtkwlf/rendall';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useRendallApi } from '../use-rendall-api';

export const getUserInfoQueryKey = () => ['rendall', 'user-info'];

/** @deprecated This endpoint will be removed */
export const useUserInfo = (options?: UseQueryOptions<User>) => {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();

  return useQuery({
    enabled: Boolean(selectedOrganization.rendallURL), // TODO AWN-217933
    queryFn: () => api.getUserInfo(),
    queryKey: getUserInfoQueryKey(),
    ...options,
  });
};
